<video #myVideo class="video-js vjs-default-skin" controls muted
    poster='{{posterURL}}' (click)="toggleVideo($event)">
    <source src="{{videoURL}}" type="video/mp4">
    Your browser does not support HTML5 video.
</video>